import { createFileRoute, notFound } from '@tanstack/react-router'
import * as v from 'valibot'

import { CompanyPage } from '@/app/manager/CompanyPage/CompanyPage'
import { CompanyInvite } from '@/company/components/CompanyInvite/CompanyInvite'
import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { FEATURE_USER_MANAGEMENT } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import { companyDepartmentsQueries } from '@/http/api/companyDepartments'

export const Route = createFileRoute('/company/_management/invite/$role')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-user-invite',
        }),
      },
    ],
  }),
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_USER_MANAGEMENT)) {
      throw notFound()
    }
  },
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(companyDepartmentsQueries.list())
  },
  params: {
    parse: (params) => ({
      role: v.parse(v.picklist(['manager', 'student']), params.role),
    }),
    stringify: ({ role }) => ({ role: `${role}` }),
  },
  component: RouteComponent,
  pendingComponent: LoadingIndicator,
})

function RouteComponent() {
  return (
    <CompanyPage>
      <CompanyInvite />
    </CompanyPage>
  )
}
